import {
  Box,
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import api from "../../../components/services/api";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Tab from "@mui/material/Tab";
import { Link } from "react-router-dom";
import { useParams } from "react-router";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";

const TrainScheduleDetail = (props) => {
  const {
    trainHeadList,
    detailTrainList,
    locationData,
    ETDDate,
    ETDTime,
    ETADate,
    ETATime,
    DepartWagonQty,
    ArriveWagonQty,
    Station,
    Status,
    Type,
  } = props;

  return (
    <>
      <Grid container rowSpacing={2} columnSpacing={2}>
        <Grid
          item
          alignItems="center"
          xs={12}
          md={12}
          lg={4}
          sx={{
            flexDirection: "rows",
            display: "flex",
            alightItem: "center",
          }}
        >
          <div
            style={{
              flexDirection: "rows",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span
              className="material-icons-outlined textcolorBule"
              style={{ fontSize: 30 }}
            >
              directions_subway
            </span>
            <h5 className="textcolorBule" style={{ margin: "0px 10px" }}>
              {trainHeadList?.Voyage}
            </h5>

            <span
              className="textcolorBule"
              style={{
                alignSelf: "start",
                fontWeight: "bold",
                fontSize: 18,
              }}
            >
              |
            </span>
            <span className="textcolorBule" style={{ marginLeft: 5 }}>
              TONS:
              <span
                style={{
                  margin: "0px 10px 0px 10px",
                  color: "black",
                }}
              >
                {+trainHeadList?.Weight / 1000}/
                {+trainHeadList?.MaxWeight / 1000}
              </span>
            </span>
          </div>
        </Grid>
        <Grid
          item
          alignItems="center"
          xs={12}
          md={12}
          lg={4}
          sx={{
            flexDirection: "rows",
            display: "flex",
            alightItem: "center",
          }}
        >
          <div
            style={{
              flexDirection: "rows",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="textcolorBule">TEUS:</span>
            <span style={{ margin: "0px 10px 0px 10px" }}>
              {trainHeadList?.Teus}/{trainHeadList?.MaxTeus}
            </span>
            <span className="textcolorBule">LOADING PERCENTAGE:</span>
            <span style={{ margin: "0px 10px 0px 10px" }}>
              {trainHeadList?.LoadingPercentage?.toFixed(2)}%
            </span>
          </div>
        </Grid>
        <Grid
          item
          alignItems="center"
          xs={12}
          md={12}
          lg={4}
          sx={{
            flexDirection: "rows",
            display: "flex",
            alightItem: "center",
            justifyContent: "flex-end",
          }}
        >
          <div style={{ display: "flex" }}>
            <Link
              to={{
                pathname: `/train/Cost/${trainHeadList?.Voyage}/${trainHeadList?.TrainRouteId}`,
              }}
            >
              <Button
                style={{
                  backgroundColor: "#007bff",
                  color: "#fafafa",
                  display: "flex",
                  justifyContent: "center",
                  marginRight: "10px",
                }}
              >
                Cost
              </Button>
            </Link>
            <Link
              to={{
                pathname: `/train/detailContainerTally/${trainHeadList?.Voyage}`,
              }}
            >
              <Button
                style={{
                  backgroundColor: "#80C340",
                  color: "#fafafa",
                  display: "flex",
                  justifyContent: "flex-end",
                  marginRight: "10px",
                }}
              >
                Container Tally
              </Button>
            </Link>
            {/* <Link
                                                to={{
                                                    pathname: `/train/Plan/${trainHeadList?.Voyage}`
                                                }}
                                            >
                                                <Button
                                                    style={{
                                                        backgroundColor: "rgb(235 62 150)",
                                                        color: "#fafafa",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    Plan
                                                </Button>
                                            </Link> */}
          </div>
        </Grid>
      </Grid>
      <Grid container sx={{ marginTop: "50px" }}>
        <Grid
          xs={12}
          sx={{
            background: "#30318D",
            padding: "10px",
            color: "#fff",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            {Type === "Inbound"
              ? `${detailTrainList?.LocationFrom} - ${detailTrainList?.LocationTo} ( ${detailTrainList?.RouteType} )`
              : `${detailTrainList?.LocationTo} - ${detailTrainList?.LocationFrom} ( ${detailTrainList?.RouteType} )`}
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            {Status ? "Open" : "Omit"}
          </Typography>
        </Grid>
        <Grid xs={12}>
          <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="center" sx={{ width: "30%" }}>
                    Station
                  </TableCell>
                  <TableCell align="center" sx={{ width: "20%" }}>
                    ETA Date
                  </TableCell>
                  <TableCell align="center" sx={{ width: "5%" }}>
                    ETA Time
                  </TableCell>
                  <TableCell align="center" sx={{ width: "20%" }}>
                    ETD Date
                  </TableCell>
                  <TableCell align="center" sx={{ width: "5%" }}>
                    ETD Time
                  </TableCell>
                  <TableCell align="center" sx={{ width: "15%" }}>
                    Wagon QTY
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <TextField
                      value={
                        Type === "Inbound"
                          ? detailTrainList?.LocationFrom || ""
                          : detailTrainList?.LocationTo || ""
                      }
                      disabled
                      fullWidth
                      label="Station"
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell> </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <DesktopDatePicker
                      disabled
                      label="date"
                      value={ETDDate || null}
                      inputFormat="dd/MM/yyyy"
                      renderInput={(params) => (
                        <TextField
                          disabled
                          size="small"
                          fullWidth
                          {...params}
                        />
                      )}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      disabled
                      value={ETDTime || ""}
                      fullWidth
                      label="time"
                      type="time"
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      disabled
                      value={DepartWagonQty || "0"}
                      fullWidth
                      label="WagonQty"
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
                {Station?.map((x, i) => (
                  <TableRow>
                    <TableCell>
                      <FormControl disabled fullWidth size="small">
                        <InputLabel id="locationFrom">Location</InputLabel>
                        <Select
                          value={x?.LocationId || ""}
                          label="Location"
                          disabled
                        >
                          {locationData.map((x) => (
                            <MenuItem value={x.LocationId}>
                              {x.LocationName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <DesktopDatePicker
                        label="date"
                        disabled
                        value={x.ETADate || null}
                        inputFormat="dd/MM/yyyy"
                        // minDate={dateStart ? dateStart : new Date()}

                        renderInput={(params) => (
                          <TextField
                            size="small"
                            fullWidth
                            disabled
                            {...params}
                          />
                        )}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        disabled
                        value={x?.ETATime || ""}
                        fullWidth
                        label="time"
                        type="time"
                        size="small"
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell>
                      <DesktopDatePicker
                        label="date"
                        value={x.ETDDate || null}
                        inputFormat="dd/MM/yyyy"
                        minDate={new Date(x.ETADate)}
                        disabled
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            fullWidth
                            disabled
                            {...params}
                          />
                        )}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        disabled
                        value={x?.ETDTime || ""}
                        fullWidth
                        label="time"
                        type="time"
                        size="small"
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        disabled
                        value={x?.WagonQty}
                        fullWidth
                        label="WagonQty"
                        size="small"
                        variant="outlined"
                      />
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell>
                    <TextField
                      disabled
                      value={
                        Type === "Inbound"
                          ? detailTrainList?.LocationTo || ""
                          : detailTrainList?.LocationFrom || ""
                      }
                      fullWidth
                      label="Station"
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell>
                    {" "}
                    <DesktopDatePicker
                      disabled
                      label="date"
                      value={ETADate || null}
                      inputFormat="dd/MM/yyyy"
                      // minDate={dateStart ? dateStart : new Date()}

                      renderInput={(params) => (
                        <TextField
                          disabled
                          size="small"
                          fullWidth
                          {...params}
                        />
                      )}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      disabled
                      value={ETATime || ""}
                      fullWidth
                      label="time"
                      type="time"
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <TextField
                      disabled
                      value={ArriveWagonQty || "0"}
                      fullWidth
                      label="WagonQty"
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Divider sx={{ marginBottom: 5, marginTop: 5 }} />
      <Box className="Flipped" sx={{ marginTop: "10px", overflowX: "auto" }}>
        <table
          className="Content"
          style={{
            width: "200%",
            textAlign: "center",
            // border: "1px solid #e0e0e0",
          }}
        >
          <thead
            style={{
              height: 50,
              backgroundColor: "#80C340",
              color: "white",
            }}
          >
            <tr>
              <th>VOY IN</th>
              <th>VOY OUT</th>
              <th>REF NO.</th>
              <th>SO NO.</th>
              <th>BOOKING NO.</th>
              <th>TYPE</th>
              <th>QTY</th>
              <th>COMMODITY</th>
              <th>PACKAGE</th>
              <th>LINERS</th>
              <th>FREIGHT</th>
              <th>STUFFING</th>
              <th>CLOSING</th>
              <th>ETD POL</th>
              <th>TERMINAL</th>
              <th>FEEDER</th>
              <th>STATUS</th>
            </tr>
          </thead>
          <tbody>
            {trainHeadList?.Detail?.map((data, index) => {
              return (
                <tr>
                  <td>
                    {data?.InboundVoyNo || ""} {data?.InboundVoyNo_2 || ""}{" "}
                    {data?.InboundVoyNo_3 || ""}
                  </td>
                  <td>
                    {data?.OutboundVoyNo || ""} {data?.OutboundVoyNo_2 || ""}{" "}
                    {data?.OutboundVoyNo_3 || ""}
                  </td>
                  <td>{data?.ShipperRefNo}</td>
                  <td>
                    <Link
                      to={"/CustomerSupport/EditSaleOrder/" + data?.SaleOrderId}
                    >
                      {data?.SaleOrderNo}
                    </Link>
                  </td>
                  <td>{data?.BookingNo}</td>
                  <td>{data?.ContainerStockType}</td>
                  <td>{data?.Quantity}</td>
                  <td>{data?.Commodity}</td>
                  <td>{data?.Package}</td>
                  <td>{data?.Liners}</td>
                  <td>{data?.FreightForwarder}</td>
                  <td>{data?.Stuffing}</td>
                  <td>{data?.ClosingDate}</td>
                  <td>{data?.ETDPOLDate}</td>
                  <td>{data?.Terminal}</td>
                  <td>{data?.FeederVessel}</td>
                  {/* <td>{data?.Remark || ""}</td> */}

                  <td>
                    {data?.SaleOrderStatus === null
                      ? null
                      : data?.SaleOrderStatus == 1
                      ? "New"
                      : data?.SaleOrderStatus == 2
                      ? "Processing"
                      : data?.SaleOrderStatus == 3
                      ? "AssignToPlanner"
                      : data?.SaleOrderStatus == 4
                      ? "AssignToCy"
                      : data?.SaleOrderStatus == 5
                      ? "Confirm"
                      : data?.SaleOrderStatus == 6
                      ? "AssigntoDocument"
                      : data?.SaleOrderStatus == 7
                      ? "AssigntoAdmin"
                      : data?.SaleOrderStatus == 8
                      ? "Complete"
                      : "Cancle"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Box>
    </>
  );
};

export default function ViewTrainSchedule() {
  const { id } = useParams();

  const [trainHeadList, settrainHeadList] = useState({});
  const [value, setValue] = useState("1");
  const [locationData, setLocationData] = useState([]);
  const [page, setPage] = useState({});

  const [trainHeadListOut, settrainHeadListOut] = useState({});
  const [detailTrainList, setDetailTrainList] = useState(null);
  const TrainScheduleDetails = async () => {
    try {
      await api.get(`api/train/detail/station/${id}`).then((res) => {
        setDetailTrainList(res.data);

        // const inB = res.data.InboundStation?.map((x, i) => {
        //   x.id = i + 1

        //   return x;
        // });

        // setRows([...inB]);
        // const outB = res.data.OutboundStation?.map((x, i) => {
        //   x.id = i + 1

        //   return x;
        // });

        // setRowsOut([...outB]);
      });
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const gettrainVoyInDetail = async () => {
    try {
      const result = await api.get("api/train/detail/" + id);
      // const result = await api.post("api/train/detail", {VoyNo: VoyIn });
      const _result = result.data;
      setPage(_result.page);
      settrainHeadList(_result.Inbound);
      settrainHeadListOut(_result.Outbound);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const getLocation = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setLocationData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  // const gettrainContainerDetail = async () => {
  //   try {
  //     const result = await api.post("api/train/container", { voy });
  //     const _result = result.data;
  //     setContainerList(_result);
  //     if (_result) {
  //       const qty20 = _result
  //         ?.filter((x) => x.Size === "20'")
  //         .map((item) => item.Qty)
  //         .reduce((prev, cur) => {
  //           return prev + parseInt(cur, 10);
  //         }, 0);
  //       const qty40 = _result
  //         ?.filter((x) => x.Size === "40'")
  //         .map((item) => item.Qty)
  //         .reduce((prev, cur) => {
  //           return prev + parseInt(cur, 10);
  //         }, 0);
  //       setQty20(qty20);
  //       setQty40(qty40);
  //     }
  //   } catch (error) {
  //     console.log("error => ", error);
  //   }
  // };

  useEffect(() => {
    // if ((VoyIn, VoyOut)) {
    gettrainVoyInDetail();
    TrainScheduleDetails();
    getLocation();
    // gettrainVoyOutDetail();
    // gettrainContainerDetail();
    // }
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Card
          variant="outlined"
          style={{
            padding: "20px",
            margin: "25px",
            height: "86vh",
            maxHeight: "86vh",
            overflow: "auto",
          }}
        >
          <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
            แผนตารางรถไฟ
          </h6>

          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Train Planning
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", flexDirection: "row" }}>
              <Typography className="textcolorBule">Train </Typography>
              <Typography>
                <span>&nbsp;</span> / Train Planning
              </Typography>
            </Grid>
          </Grid>

          <form>
            <Grid sx={{ padding: "40px 70px 40px 70px" }}>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <div style={{ display: "flex", gap: "15px" }}>
                  {page?.previousPage && (
                    <a
                      href={`/Planner/ViewTrainSchedule/${page?.previousPage}`}
                    >
                      <Button
                        style={{
                          backgroundColor: "#007bff",
                          color: "#fafafa",
                          display: "flex",
                          justifyContent: "center",
                          marginRight: "10px",
                        }}
                      >
                        {`< Previous`}
                      </Button>
                    </a>
                  )}
                  {page?.nextPage && (
                    <a href={`/Planner/ViewTrainSchedule/${page?.nextPage}`}>
                      <Button
                        style={{
                          backgroundColor: "#007bff",
                          color: "#fafafa",
                          display: "flex",
                          justifyContent: "center",
                          marginRight: "10px",
                        }}
                      >
                        {`Next >`}
                      </Button>
                    </a>
                  )}
                </div>
              </div>

              <TabContext value={value}>
                <Box
                  sx={{ borderBottom: 1, borderColor: "divider", marginTop: 5 }}
                >
                  <TabList
                    variant="scrollable"
                    scrollButtons="auto"
                    onChange={handleChange}
                    TabIndicatorProps={{
                      style: { backgroundColor: "transparent" },
                    }}
                  >
                    <Tab
                      sx={{
                        "&.Mui-selected": {
                          background: "#80C340",
                          color: "white",
                          borderTopLeftRadius: "15px",
                          borderTopRightRadius: "15px",
                        },
                      }}
                      label={trainHeadList?.Voyage}
                      value="1"
                    />
                    <Tab
                      sx={{
                        "&.Mui-selected": {
                          background: "#80C340",
                          color: "white",
                          borderTopLeftRadius: "15px",
                          borderTopRightRadius: "15px",
                        },
                      }}
                      label={trainHeadListOut?.Voyage}
                      value="2"
                    />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <TrainScheduleDetail
                    locationData={locationData}
                    trainHeadList={trainHeadList}
                    detailTrainList={detailTrainList}
                    ETDDate={detailTrainList?.InboundETDDate}
                    ETDTime={detailTrainList?.InboundETDTime}
                    ETADate={detailTrainList?.InboundETADate}
                    ETATime={detailTrainList?.InboundETATime}
                    DepartWagonQty={detailTrainList?.InboundDepartWagonQty}
                    ArriveWagonQty={detailTrainList?.InboundArriveWagonQty}
                    Station={detailTrainList?.InboundStation}
                    Status={detailTrainList?.InboundStatus}
                    Type="Inbound"
                  />
                </TabPanel>

                <TabPanel value="2">
                  <TrainScheduleDetail
                    locationData={locationData}
                    trainHeadList={trainHeadListOut}
                    detailTrainList={detailTrainList}
                    ETDDate={detailTrainList?.OutboundETDDate}
                    ETDTime={detailTrainList?.OutboundETDTime}
                    ETADate={detailTrainList?.OutboundETADate}
                    ETATime={detailTrainList?.OutboundETATime}
                    DepartWagonQty={detailTrainList?.OutboundDepartWagonQty}
                    ArriveWagonQty={detailTrainList?.OutboundArriveWagonQty}
                    Station={detailTrainList?.OutboundStation}
                    Status={detailTrainList?.OutboundStatus}
                    Type="Outbound"
                  />
                </TabPanel>
              </TabContext>
            </Grid>
          </form>
        </Card>
      </LocalizationProvider>
    </div>
  );
}
